import { useMutation } from '@tanstack/react-query';
import { openLoading, closeLoading } from '../../../components/alert/hooks/useAlert';
import { POST, POST_CLAIM_UPDATE_BOOKING } from '../../../services';
import { openAlert } from '../../../components/alert/hooks';
import { convertYearInputToPayload } from '../../../functions/convert';
import { MONITOR_LARK } from '../../../helpers/lark';

export const useUpdateBooking = (props) => {
  const { onSuccessCallBack } = props;

  const updateBookingPost = useMutation({
    mutationFn: async (data) => {
      const requestData = {
        claimId: data.claimId,
        claimCode: data.claimCode,
        bookingDate: convertYearInputToPayload(data.bookingDate),
        reason: data.reason,
        reasonCode: data.reasonCode,
        remark: data.remark,
      };
      const response = await POST(POST_CLAIM_UPDATE_BOOKING, requestData);

      closeLoading();
      return response?.result?.item;
    },
    onSuccess: async (data) => {
      openAlert({ model: 'message', type: 'success', message: 'เปลี่ยนวันจองสำเร็จ' });
      await new Promise((resolve) => setTimeout(resolve, 1000));
      onSuccessCallBack(data);
    },
    onError: (error) => {
      const msgErr =
        error && error.message == 'NETWORK_ERROR'
          ? 'เปลี่ยนวันจองไม่สำเร็จ \nกรุณาลองใหม่อีกครั้ง'
          : error?.message;
      openAlert({ model: 'modal', type: 'error', message: msgErr });
      MONITOR_LARK({
        module: 'หน้าเปลี่ยนวันจอง',
        message: `${POST_CLAIM_INSERT} : เปลี่ยนวันจองล้มเหลว!!`,
        error,
      });
    },
  });

  const updateBooking = (data) => {
    openLoading();
    updateBookingPost.mutate(data);
  };

  const loading = updateBookingPost.isPending;

  return {
    updateBooking,
    loading,
  };
};
